import { RevenueBreakdownSchema } from '@vy/types';
import { oz } from '@vy/utils';
import { ProductClassFormInputSchema } from '../../../../CustomerInvoicePage/customer-invoice-page-components/InvoiceActivity/invoice-activity-components/InvoiceActivityTabs/invoice-activity-tabs/InvoiceActivityErpSyncTab/Invoice-activity-erp-sync-tab-components/ErpProductSettingsAccordion/erp-product-settings-accordion-types/product-class-form-input-schema';
import { ProductErpFormInputSchema } from '../../../../CustomerInvoicePage/customer-invoice-page-components/InvoiceActivity/invoice-activity-components/InvoiceActivityTabs/invoice-activity-tabs/InvoiceActivityErpSyncTab/Invoice-activity-erp-sync-tab-components/ErpProductSettingsAccordion/erp-product-settings-accordion-types/product-erp-form-input-schema';

export const PROMOTION_REVISIONED_LINE_ITEM_TYPES = Object.freeze({
  Fixed: 'FixedPromotion',
  Percentage: 'PercentagePromotion',
});

export const PromotionRevisionedLineItemTypeSchema = oz
  .nativeEnum(PROMOTION_REVISIONED_LINE_ITEM_TYPES)
  .openapi('PromotionRevisionedLineItemType');
export type PromotionRevisionedLineItemType = oz.infer<typeof PromotionRevisionedLineItemTypeSchema>;

export const basePromotionRevisionedLineItemFormSchema = oz.object({
  modifiedName: oz.string().nonempty(),
  modifiedDescription: oz.string().optional(),
  type: PromotionRevisionedLineItemTypeSchema,
  netSuiteProduct: ProductErpFormInputSchema.array().default([]),
  classMetadata: ProductClassFormInputSchema.nullish().default(null),
  xeroProductId: oz.string().nullish().default(null),
});

const FixedPromotionSchema = basePromotionRevisionedLineItemFormSchema.extend({
  type: oz.literal(PROMOTION_REVISIONED_LINE_ITEM_TYPES.Fixed),
  revenueBreakdown: RevenueBreakdownSchema,
});
export type FixedRevisionedLineItemForm = oz.infer<typeof FixedPromotionSchema>;

const PercentagePromotionSchema = basePromotionRevisionedLineItemFormSchema.extend({
  type: oz.literal(PROMOTION_REVISIONED_LINE_ITEM_TYPES.Percentage),
  percentage: oz.number().max(100).min(1),
});
export type PercentageRevisionedLineItemForm = oz.infer<typeof PercentagePromotionSchema>;

export const PromotionRevisionedLineItemFormSchema = oz.discriminatedUnion('type', [
  FixedPromotionSchema,
  PercentagePromotionSchema,
]);

export type PromotionRevisionedLineItemForm = oz.infer<typeof PromotionRevisionedLineItemFormSchema>;
